// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u2Cv","footer":"styles_footer__QM7as","passCodeTooltip":"styles_passCodeTooltip__3WaG3"};